import moment from 'moment'

import { DATE_FORMAT, DATETIME_FORMAT, daysOfTheWeek } from '@/lib/constants'

/**
 * Formats a subreddit to include the /r/ prefix.
 * @param {string} subredditName
 */
export function formatSubreddit(subredditName) {
  if (subredditName.startsWith('/r')) {
    return subredditName
  } else {
    return `/r/${subredditName}`
  }
}

export function formatDateTime(date) {
  return moment(date).format(DATETIME_FORMAT)
}

export function formatDate(date, format = DATE_FORMAT) {
  return moment(date).format(format)
}

export function formatTime(date) {
  return moment(date).format('h:mm a')
}

export function formatHour(hoursInDay) {
  let hour = hoursInDay
  let amPM = 'am'
  if (hoursInDay >= 12) {
    amPM = 'pm'
    if (hoursInDay !== 12) {
      hour = hoursInDay - 12
    }
  } else if (hoursInDay === 0) {
    hour = 12
  }
  return `${hour}:00 ${amPM}`
}

export function formatNumber(value) {
  const formatter = Intl.NumberFormat('en', { notation: 'compact' })
  return formatter.format(value).toLowerCase()
}

export function getMinutesBetweenDates(startDate, endDate) {
  const diff = endDate.getTime() - startDate.getTime()
  return Math.floor(diff / 60000)
}

export function createImgurThumbnailLink(
  url,
  thumbnailSize = 'm',
  sizeInBytes = 0
) {
  // https://api.imgur.com/models/image#thumbs
  // Sizes:
  // s = Small Square (90x90)
  // b = Big Square (160x160)
  // t = Small Thumbnail (160x160)
  // m = Medium Thumbnail (320x320)
  // l = Large Thumbnail (640x640)
  // h = Huge Thumbnail (1024x1024)

  // Imgur API returns GIFs as thumbnails automatically
  // if they are larger than 20 MB
  if (url.endsWith('.gif') && sizeInBytes > 20971520) {
    return url
  }

  let parts = url.split('.')
  parts[parts.length - 2] = parts[parts.length - 2] + thumbnailSize
  return parts.join('.')
}

export function dayOfTheWeekFromPython(dayIndex) {
  let day = null
  if (dayIndex === 6) {
    day = 0
  } else {
    day = dayIndex + 1
  }
  return daysOfTheWeek[day]
}

export function ensureMaxCharacters(string, max) {
  if (string.length > max) {
    return string.substring(0, max - 3) + '...'
  } else {
    return string
  }
}

export function parseQSArray(qsArray) {
  if (typeof qsArray === 'string') {
    return qsArray.split(',')
  } else if (Array.isArray(qsArray)) {
    return qsArray
  } else {
    return []
  }
}

export function titleCase(string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase()
}

function stringToNumber(string) {
  let text = string
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]/gi, '')
  let number = 0
  for (let i = 0; i < text.length; i++) {
    number += str.charCodeAt(i)
  }
  return number
}

/**
 * Returns a deterministic time delta in minutes.
 */
export function recommendationToMinutes(userId, subreddit, isoWeekday, hour) {
  let number = userId * stringToNumber(subreddit) * hour * isoWeekday

  // Get a number between 0 and 55
  number = number % 55

  // Round to the nearest 5
  number = Math.round(number / 5) * 5

  return number
}

export function getRandomMinuteInterval() {
  let minutes = Math.floor(Math.random() * 55)
  return (minutes = Math.round(minutes / 5) * 5)
}
